/**
 * Hash an email with a secret key (HMAC-SHA256) using Web Crypto.
 */
export async function hashEmail(email: string, secret: string) {
  const normalizedEmail = email.trim().toLowerCase().normalize('NFKC'); // <- match BE;
  if (!normalizedEmail || !secret) {
    return '';
  }

  const subtle = getSubtleCrypto();
  const encoder = new TextEncoder();

  const key = await subtle.importKey(
    'raw',
    encoder.encode(secret),
    {
      name: 'HMAC',
      hash: { name: 'SHA-256' }
    },
    false,
    ['sign']
  );

  const signature = await subtle.sign(
    'HMAC',
    key,
    encoder.encode(normalizedEmail)
  );
  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Check if an email hashes to a given value.
 */
export async function verifyEmailHash(
  email: string,
  hashValue: string,
  secret: string
) {
  if (!hashValue || !secret) {
    return false;
  }

  const computed = await hashEmail(email, secret);
  console.log('computed hash', computed);
  console.log('secret ', secret);
  return timingSafeEqual(computed, hashValue);
}

const getSubtleCrypto = () => {
  if (typeof globalThis !== 'undefined' && globalThis.crypto?.subtle) {
    return globalThis.crypto.subtle;
  }
  throw new Error('Web Crypto API is not available in this environment.');
};

const bufferToHex = (buffer: ArrayBuffer) => {
  return Array.from(new Uint8Array(buffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

const timingSafeEqual = (first: string, second: string) => {
  if (!first || !second || first.length !== second.length) {
    return false;
  }

  let result = 0;
  for (let i = 0; i < first.length; i += 1) {
    result |= first.charCodeAt(i) ^ second.charCodeAt(i);
  }
  return result === 0;
};
